<template>
    <div class="content">
        <div class="path" id="path" v-if="pulse.show"><img :src="img(require('@/assets/images/GIF/caiPath.gif'))"></div>
        <div class="circular">
            <p id="num_cai_text">0</p>
            <main>
                <h3>采</h3>
                <div class="beam"></div>
                <div class="bg rotateX">
                    <div class="rotateZ"></div>
                </div>
            </main>
        </div>
        <img src="../../assets/images/caiBG.png" alt="" class="rotateZ">
        <div>
            <div class="cai-text cai-text1">
                <h4>新华社稿</h4>
                <p>{{dataList.xhsCount}}</p>
            </div>
            <div class="cai-text cai-text2">
                <h4>互联网稿件</h4>
                <p>{{dataList.netCount}}</p>
            </div>
            <div class="cai-text cai-text3">
                <h4>记者站稿件</h4>
                <p>{{dataList.ugcCount}}</p>
            </div>
            <div class="cai-text cai-text4">
                <h4>本部原创稿件</h4>
                <p>{{dataList.bbycCount}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import {numAnimation} from '../../assets/js/common'
    export default {
        name: "caiModule",
        data() {
            return {
                dataList: [],
                pulse: {
                    show: false,
                    dur: 1700
                },
                timer: null
            }
        },
        mounted(){
            this.getDataList();
            this.timer =setInterval(() => {
                this.getDataList();
            }, 1000*60*15);
        },
        watch: {
            dataList: function (n, o) {
                if (n.caiCount !== o.caiCount && n.caiCount !== 0) {
                    this.pulse.show = true;
                    setTimeout(() => {
                        numAnimation("num_cai_text", {
                            time: 1500,
                            num: n.caiCount,
                            regulator: 100,
                            start: o.caiCount ? o.caiCount : 0,
                        });
                        this.pulse.show = false;
                    }, this.pulse.dur);
                }
            }
        },
        computed: {
            img(){
                return function (path) {
                    return path + '?' + new Date().getTime();
                }
            },
        },
        methods: {
            getDataList(){
                this.axios.get('/bigscreen/mediacaidata.json').then(res => {
                    if (res.data.data.caiCount && res.data.data.caiCount>0) {
                        this.dataList = res.data.data;
                    }
                })
            },

        },
        beforeDestroy(){
            clearInterval(this.timer);
        },
    }
</script>

<style scoped>
    .content{
        position: relative;
    }
    .content .path{
        position: absolute;
        top: 154px;
        left: -49px;
    }
    .content img{
        top: 50px;
        right: -16px;
        position: absolute;
    }
    .content .cai-text h4{
        font-size: 24px;
        font-weight: normal;
        text-align: center;
    }
    .content .cai-text p{
        color: #4afffd;
        font-size: 26px;
        text-align: center;
    }
    .cai-text1{
        position: absolute;
        top: 30px;
        left: -240px;
    }
    .cai-text2{
        position: absolute;
        top: 30px;
        right: -150px;
    }
    .cai-text3{
        position: absolute;
        top: 180px;
        left: -240px;
    }
    .cai-text4{
        position: absolute;
        top: 180px;
        right: -160px;
    }
    .circular{
        width: 184px;
        height: 184px;
        position: absolute;
        right: 260px;
        top: 270px;
    }
    .circular main{
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .circular .bg{
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
    .circular .bg.rotateX{
        transform: rotateX(60deg);
    }
    .circular .rotateZ{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: url("../../assets/images/circle.png") center center no-repeat;
        background-size: 100% 100%;
        transform: rotateZ(60deg);
        animation: circular-bg 5s linear 0s infinite normal;
    }
    .circular h3{
        font-size: 48px;
    }
    .circular p{
        font-size: 50px;
        color: #eacb42;
        font-weight: bold;
        text-align: center;
    }
    img.rotateZ{
        transform: rotateZ(60deg);
        animation: circular-bg 5s linear 0s infinite normal;
    }
    .beam{
        width: 180px;
        height: 129px;
        position: absolute;
        background: url(../../assets/images/beam.png)center center no-repeat;
        background-size: 100% 100%;
        bottom: 70px;
        left: 0px;
    }
    @keyframes circular-bg {
        0% {transform: rotateZ(60deg);}
        100% {transform: rotateZ(420deg)}
    }
</style>
